<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        label-width="140px"
        ref="form"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="姓名：" prop="Name"
          ><el-input
            placeholder="姓名"
            v-model="dataForm.Name"
            clearable
            maxlength="10"
          ></el-input
        ></el-form-item>
        <el-form-item label="本人或家属电话：" prop="Phone"
          ><el-input
            placeholder="本人或家属电话"
            v-model="dataForm.Phone"
            clearable
            maxlength="11"
          ></el-input
        ></el-form-item>
        <el-form-item label="身份证号码：" prop="IdentityCard"
          ><el-input
            placeholder="身份证号码"
            v-model="dataForm.IdentityCard"
            clearable
            maxlength="18"
          ></el-input
        ></el-form-item>
        <!--        <el-form-item label="家属姓名：" prop="FamilyName"-->
        <!--          ><el-input-->
        <!--            placeholder="家属姓名"-->
        <!--            v-model="dataForm.FamilyName"-->
        <!--            clearable-->
        <!--            maxlength="10"-->
        <!--          ></el-input-->
        <!--        ></el-form-item>-->
        <!--        <el-form-item label="家属电话：" prop="FamilyPhone"-->
        <!--          ><el-input-->
        <!--            placeholder="家属电话"-->
        <!--            v-model="dataForm.FamilyPhone"-->
        <!--            clearable-->
        <!--            maxlength="11"-->
        <!--          ></el-input-->
        <!--        ></el-form-item>-->
        <el-form-item label="登记地：" prop="RegisterAddress">
          <v-region
            v-model="addre"
            @values="regionChange"
          ></v-region>
        </el-form-item>
        <el-form-item label="捐献意愿：" prop="Willingness">
          <el-checkbox-group
            v-model="checkedwillingness"
            :min="0"
            :max="4"
            @change="handleChecked"
          >
            <el-checkbox
              v-for="item in willingness"
              :label="item"
              :key="item"
              >{{ item }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="登记时间:" prop="CreateTime">
          <el-date-picker
            v-model="dataForm.CreateTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="OPO/获取单位：" prop="Opo"
          ><el-input
            placeholder="OPO/获取单位"
            v-model="dataForm.Opo"
            clearable
            maxlength="10"
          ></el-input
        ></el-form-item>
        <el-form-item label="救助人数：" prop="RescueNum"
          ><el-input
            placeholder="救助人数"
            v-model="dataForm.RescueNum"
            clearable
            maxlength="10"
            type="number"
          ></el-input
        ></el-form-item>
        <el-form-item label="器官例数：" prop="OrganCases"
          ><el-input
            placeholder="器官例数"
            v-model="dataForm.OrganCases"
            clearable
            maxlength="10"
            type="number"
          ></el-input
        ></el-form-item>
        <el-form-item label="动员及摘取医院：" prop="ExtractHospital"
          ><el-input
            placeholder="动员及摘取医院"
            v-model="dataForm.ExtractHospital"
            clearable
            maxlength="10"
          ></el-input
        ></el-form-item>
        <el-form-item label="状态：" prop="Status">
          <el-select v-model="dataForm.Status" placeholder="状态">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    //验证身份证号码
    var checkIdentityCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号码"));
      }
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return callback(new Error("无效身份证号码"));
      }
      callback();
    };
    return {
      editFormRules: {
        Name: {
          required: true,
          message: "请输入姓名",
          trigger: "blur",
        },
        Phone: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur",
        },
        IdentityCard: {
          required: true,
          validator: checkIdentityCard,
          trigger: "blur"
        },
        // FamilyName: {
        //   required: true,
        //   message: "请输入家属姓名",
        //   trigger: "blur",
        // },
        // FamilyPhone: {
        //   required: true,
        //   validator: checkMobileNo,
        //   trigger: "blur",
        // },
        RegisterAddress: {
          required: true,
          message: "请输入登记地",
          trigger: "blur",
        },
        // Willingness: {
        //   required: true,
        //   message: "请选择捐献意愿",
        //   trigger: "blur",
        // },
        CreateTime: {
          required: true,
          message: "请选择登记时间",
          trigger: "blur",
        },
        Opo: {
          required: true,
          message: "请输入OPO/获取单位",
          trigger: "blur",
        },
        RescueNum: {
          required: true,
          message: "请输入救助人数",
          trigger: "blur",
        },
        OrganCases: {
          required: true,
          message: "请输入器官例数",
          trigger: "blur",
        },
        ExtractHospital: {
          required: true,
          message: "请输入动员及摘取医院",
          trigger: "blur",
        },
      }, //表单校验
      formTitle: "遗体器官捐献登记信息", //标题
      isConfirm: false,
      width: "50%", //弹窗宽度
      dataForm: {}, //表单数据
      status: [
        { value: 0, label: "未完成" },
        { value: 1, label: "已完成" },
      ], //状态
      willingness: ["器官", "眼角膜", "组织", "遗体"], //捐献意愿选项
      checkedwillingness: [], //捐献意愿选中数组
      addre: {
        province: "",
        city: "",
        area: "",
        town: "",
      }, //地址
    };
  },
  components: {
    OfDialog,
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      if(that.id !== ''){
        let params = { Id: that.id };
        api.QueryDonationOrganById(params).then((res) => {
          if (res.data.Code == 0) {
            that.dataForm = res.data.Data;
            that.dataForm.CreateTime = that.dataForm.CreateTime * 1000;
            that.checkedwillingness = that.dataForm.Willingness.split(",");
            let addrArry = that.dataForm.RegisterAddress.split(",");
            that.addre = {
              province: addrArry[0],
              city: addrArry[1],
              area: addrArry[2],
              // town: addrArry[3],
              town: ''
            };
          }
        });
      }
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          if(!that.dataForm.Willingness || that.dataForm.Willingness === ''){
            this.$message.error('请选择捐献意愿');
            return
          }
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.CreateTime = params.CreateTime / 1000;
          api
            .SaveDonationOrgan(params)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
          that.isConfirm = false;
        }
      });
    },
    //捐献意愿选中
    handleChecked(val) {
      let that = this;
      that.dataForm.Willingness = "";
      that.checkedwillingness.forEach((item) => {
        if (that.dataForm.Willingness) {
          that.dataForm.Willingness = that.dataForm.Willingness + "," + item;
        } else {
          that.dataForm.Willingness = item;
        }
      });
    },
    //地址选择
    regionChange(data) {
      let that = this;
      let province = data.province !== null ? data.province.key : "";
      let city = data.city !== null ? data.city.key : "";
      let area = data.area !== null ? data.area.key : "";
      // let town = data.town !== null ? data.town.key : "";
      that.dataForm.RegisterAddress =
        province + "," + city + "," + area 
      let provinceMsg = data.province !== null ? data.province.value : "";
      let cityMsg = data.city !== null ? data.city.value : "";
      let areaMsg = data.area !== null ? data.area.value : "";
      that.dataForm.RegisterAddressMsg =
        provinceMsg + "," + cityMsg + "," + areaMsg 
    },
  },
};
</script>

<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
</style>
